const GET_ASSET_ITEM_STATUS_VENDOR_DETAIL = 'GET_ASSET_ITEM_STATUS_VENDOR_DETAIL'
const SET_ASSET_ITEM_STATUS_VENDOR_DETAIL = 'SET_ASSET_ITEM_STATUS_VENDOR_DETAIL'

 const SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED = "SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED"

export {
    GET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    SET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED
}
